export default __webpack_public_path__ + "static/media/97_header_quotation.53a4e0bb.png";